"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseFooterComponent = /** @class */ (function () {
    function FuseFooterComponent() {
    }
    return FuseFooterComponent;
}());
exports.FuseFooterComponent = FuseFooterComponent;
